import {
    ArtifactEvidence,
    ArtifactFrame,
    ArtifactLifecycleStatusBadge,
} from '@apps/web/routes/_app/admin/agent/artifacts/frame';
import {
    type AdminArtifactRendererProps,
    BoundedArtifactPayload,
} from '@apps/web/routes/_app/admin/agent/artifacts/shared';
import { describeStructuredPayload } from '@apps/web/routes/_app/admin/agent/tool_output_data_renderer';

/**
 * Readable default renderer for structured-payload artifacts: a one-line
 * outcome summary followed by the size-capped field tree. Registered per
 * artifact type so nothing falls through to the "no dedicated renderer"
 * warning.
 */
export function StructuredPayloadArtifact({
    artifact,
}: AdminArtifactRendererProps) {
    const summary = describeStructuredPayload(artifact.payload);
    return (
        <ArtifactFrame
            artifact={artifact}
            status={
                <ArtifactLifecycleStatusBadge
                    lifecycleStatus={artifact.lifecycle_status}
                />
            }
        >
            {summary ? (
                <p className="text-foreground font-mono text-[12px]">
                    {summary}
                </p>
            ) : null}
            <BoundedArtifactPayload payload={artifact.payload} />
            <ArtifactEvidence artifact={artifact} />
        </ArtifactFrame>
    );
}
